import React, { useEffect, useState, useCallback } from 'react';
import { useRouter } from 'next/router';
import { Image, Nav, Offcanvas, ToastContainer } from 'react-bootstrap';
import Link from 'next/link';
import { useAppSelector } from '@/lib/redux/store';
import ToastMessage from '@/components/ToastMessage';
import { useToasts } from '@/hooks/toasts';
import { useAuth } from '@/hooks/auth';
import { useSelector } from 'react-redux';

const AdminSuperLayout = ({ children }) =>
{
  const router = useRouter();
  const store = useAppSelector((state) => state.app);
  const persist = useSelector((state) => state._persist);
  const { user, roleActingAs, userEntityRoles } = store;
  const logo = '/images/instant-polls-logo.jpg';
  const { logout, isInstantPollsUser } = useAuth();
  const { toasts, removeToast } = useToasts();
  const pathname = router.pathname;
  const [showSidebar, setShowSidebar] = useState(false);



  const handleSidebarShow = () => setShowSidebar(true);
  const handleSidebarClose = () => setShowSidebar(false);

  const handleLogout = () =>
  {
    logout();
  };
  const [sidebarLinks, setSidebarLinks] = useState([
    { label: 'Home', href: '/admin/dashboard', icon: 'bi bi-house-door' },
    { label: 'Staff Access', href: '/admin/staff', icon: 'bi bi-person-fill-check' },
    { label: 'Customers', href: '/admin/customers', icon: 'bi bi-person' },
    { label: 'Resellers', href: '/admin/resellers', icon: 'bi bi-receipt' },
    { label: 'Sales Analysis', href: '/admin/sales-analysis', icon: 'bi bi-graph-up' },
    { label: 'Pricing', href: '/admin/pricing', icon: 'bi bi-cash-coin' },
    { label: 'Invoices', href: '/admin/invoices', icon: 'bi bi-credit-card-2-front' },
    { label: 'Polls', href: '/admin/polls', icon: 'bi bi-bar-chart' },
    { label: "T&C's and Privacy", href: '/admin/terms-privacy', icon: 'bi bi-shield-lock' },
    { label: "FAQ's", href: '/admin/faq', icon: 'bi bi-question-circle' },
    { label: 'Security', href: '/admin/security', icon: 'bi bi-shield-lock' },
    {
      label: 'Logout',
      href: '#',
      icon: 'bi bi-box-arrow-right',
      onClick: handleLogout
    },
  ]);




  useEffect(() =>
  {
    // if !user and persist is rehydrated, redirect to login
    if (persist?.rehydrated && !user)
    {
      router.push('/login');
      return;
    }
    // if roleActingAs is not set, redirect to select role page
    if (persist?.rehydrated && !roleActingAs)
    {
      // router.push('/select-role');
      return;
    }

    // Filter sidebar links based on the user's role
    if (roleActingAs?.role?.name === 'Sales')
    {
      setSidebarLinks((prevLinks) =>
        prevLinks.filter(
          (link) =>
            link.label !== 'Staff Access' &&
            link.label !== 'Pricing' &&
            link.label !== "T&C's and Privacy" &&
            link.label !== "FAQ's" &&
            link.label !== "Pricing" &&
            link.label !== 'Resellers'
        )
      );
    }

  }, [persist?.rehydrated, roleActingAs, router, user]);



  const isActive = useCallback(
    (path) =>
    {
      if (!path || !pathname) return false;

      const pathSegments = path.split('/');
      const lastSegment = pathSegments[pathSegments.length - 1];
      const pathnameSegments = pathname.split('/');
      const lastPathnameSegment = pathnameSegments[pathnameSegments.length - 1];
      // return lastSegment === lastPathnameSegment;
      return pathname === path || pathname.startsWith(path + '/');
    },
    [pathname]
  );



  // if (userEntityRoles.length > 1)
  // {
  //   sidebarLinks.splice(sidebarLinks.length - 1, 0, {
  //     label: 'Select Role',
  //     href: '/select-role',
  //     icon: 'bi bi-person-circle',
  //   });
  // }
  if (userEntityRoles.length > 1 && !sidebarLinks.some(l => l.label === 'Select Role'))
  {
    sidebarLinks.splice(sidebarLinks.length - 1, 0, {
      label: 'Select Role',
      href: '/select-role',
      icon: 'bi bi-person-circle',
    });
  }

  if (!isInstantPollsUser(roleActingAs))
  {
    return <div className="p-4 text-danger">Access Denied</div>;
  }


  return (
    <div className="backend">
      <section className="d-flex position-relative">
        {/* Mobile Navbar */}
        <nav className="navbar navbar-light bg-light d-lg-none px-3 w-100">
          <button className="btn" type="button" onClick={handleSidebarShow}>
            <i className="bi bi-list fs-2"></i>
          </button>
          <Link className="navbar-brand ms-2 mobileResponse" href="/">
            <Image src={logo} alt="Logo" height={40} />
          </Link>
        </nav>

        {/* Sidebar Offcanvas */}
        <Offcanvas
          show={showSidebar}
          onHide={handleSidebarClose}
          responsive="lg"
          className="sticky-lg-top p-3"
          backdrop={false}
        >
          <Offcanvas.Body className="d-flex flex-column canvasadmin">
            <Link className="navbar-brand mb-3" href="/admin/dashboard">
              <Image src={logo} alt="Instant Polls Logo" className="adminNavImg" />
            </Link>

            <p className="text-center highlightedColor border-2 rounded">
              <strong className="d-block pt-1 highlightedColor">{user?.name}</strong>
              <span className=' highlightedColor' >
                {roleActingAs?.role?.name}
              </span>
            </p>

            <Nav className="nav-pills flex-column mb-auto">
              {sidebarLinks.map((link, index) => (
                <Nav.Item key={index}>
                  {link.label === 'Logout' ? (
                    <a href="#" className="nav-link p-2" onClick={link.onClick}>
                      <i className={link.icon}></i>
                      <span className="ms-3 nav-text">{link.label}</span>
                    </a>
                  ) : (
                    <Link
                      href={link.href}
                      className={`nav-link p-2 ${isActive(link.href) ? 'custom-active' : ''}`}
                      onClick={handleSidebarClose}
                    >
                      <i className={link.icon}></i>
                      <span className="ms-3 nav-text">{link.label}</span>
                    </Link>
                  )}
                </Nav.Item>
              ))}
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Content Area */}
        <div id="content" className="flex-grow-1">
          <div className="container-fluid p-3 p-lg-4">{children}</div>

          {/* Toast Messages */}
          <ToastContainer position="top-end" className="p-3 z-index-top">
            {toasts?.map((toast, index) => (
              <ToastMessage
                key={index}
                onClose={() => removeToast(toast.id)}
                message={toast.message}
                variant={toast.variant}
              />
            ))}
          </ToastContainer>
        </div>
      </section>
    </div>
  );
};

export default AdminSuperLayout;
